/**
 * Image shown on the large AI prep stage.
 * Turning Remove background on (viewingCutout) shows the PNG cutout even when
 * a generated result exists. A later generate clears that flag so the result
 * comes back. The Original card always shows the source.
 */
export function resolveAiPrepStageImage({
  stageKey,
  sourceImageUrl = null,
  resultImageUrl = null,
  removeBg = false,
  cutoutUrl = null,
  viewingCutout = false,
}) {
  if (stageKey === "preview") {
    if (viewingCutout && removeBg && cutoutUrl) return cutoutUrl;
    if (resultImageUrl) return resultImageUrl;
    if (removeBg && cutoutUrl) return cutoutUrl;
  }
  return sourceImageUrl;
}

export function aiPrepStageIsTransparent({
  stageKey,
  removeBg = false,
  cutoutUrl = null,
  viewingCutout = false,
  resultImageUrl = null,
}) {
  if (stageKey !== "preview" || !removeBg || !cutoutUrl) return false;
  if (viewingCutout) return true;
  return !resultImageUrl;
}
